import { useSelfServeAndPermissions } from '@/hooks/permissions/useSelfServeAndPermissions'
import { PATHS } from '@/routes/PATHS'
import { useMemo } from 'react'
import { useLocation } from 'react-router'

export const useFullLayout = () => {
  const { canDoUpgrade, shouldDoUpgrade } = useSelfServeAndPermissions()
  const { pathname } = useLocation()
  const isNoLocationsPage = pathname === PATHS.noLocations

  const isFullLayout = useMemo(
    () => !canDoUpgrade || !shouldDoUpgrade || isNoLocationsPage,
    [canDoUpgrade, isNoLocationsPage, shouldDoUpgrade],
  )

  return isFullLayout
}
